import {useState} from "react";
import {apartmentSearchAPI, API_APARTMENT_SEARCH_AVAILABILITY} from "../common/api";
import {createURLQuery} from "../common/api/apiUtil";
import {cloneDeep} from "lodash";

export const useApartmentSearchAvailability = () => {
    const [apartmentAvailability, setApartmentAvailability] = useState();
    const [loadingApartmentAvailability, setLoadingApartmentAvailability] = useState(false);
    const [originalApartmentAvailability, setOriginalApartmentAvailability] = useState();
    const [error, setError] = useState(null);

    const loadApartmentAvailability = (params) => {
        setLoadingApartmentAvailability(true);
        setApartmentAvailability();
        setError(null);

        apartmentSearchAPI.get(API_APARTMENT_SEARCH_AVAILABILITY + createURLQuery(params))
            .then(res => {
                const response = res.data;
                const availability = response?.apartment_category_availability;
                setApartmentAvailability(cloneDeep(availability));
                setOriginalApartmentAvailability(cloneDeep(availability));
                setLoadingApartmentAvailability(false);
            })
            .catch(err => {
                setApartmentAvailability(null);
                setError(err);
                setLoadingApartmentAvailability(false);
            });

    };

    const resetApartmentAvailability = () => {
        setApartmentAvailability(cloneDeep(originalApartmentAvailability));
    };

    return {
        apartmentAvailability,
        setApartmentAvailability,
        loadApartmentAvailability,
        resetApartmentAvailability,
        loadingApartmentAvailability,
        error
    };
};
